<li class="mr-3 dropdown_li">
  @if (showInvestorsDropList() && iconSet()) {
    <div class="text-right pl-2 lg:pl-0 lg:flex">
      @if (!externalUser) {
        <form class="filter-form mt-1">
          <div class="flex mr-2">
            <mat-form-field class="mt-1 filter-form-field portfolio-filter">
              <mat-icon fontIcon="filter_alt" class="mr-1"></mat-icon>
              <input type="text" placeholder="Filter by portfolio" matInput [formControl]="searchInput"
                [matAutocomplete]="auto">
                @if (searchInput.value !== '') {
                  <mat-icon aria-label="close icon" class="pt-1.5 pointer close-icon"
                  fontIcon="close_small" color="red" title="Clear Filter" (click)="resetFilter()"></mat-icon>
                }
                <mat-autocomplete #auto="matAutocomplete" [hideSingleSelectionIndicator]="true"
                  [displayWith]="displayFn" panelWidth="40%" (optionSelected)="filterSelectedPortfolio()">
                  @if (noMatchFilterError) {
                    <mat-option disabled="true">No matching investors with a portfolio
                      name or ticker:
                    {{searchInput.value}}</mat-option>
                  }
                  @for (option of filteredOptions(); track option) {
                    <mat-option [value]="option">
                      {{option.ticker}} - {{option.name}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </form>
        }
        <div class="investorIds mt-1.5">
          <img src="{{iconSet()['icon.investor.dropdown']}}" alt="investor-dropdown"
            class="investorIds__icon mt-4 lg:mt-0" />
            <app-auto-adjusting-dropdown [selected]="investorName()" [dataForBreadcrumbs]="filteredInvestorDropdownData()"
              (goToSelected)="selectActiveInvestor(+$any($event))"
              [selectedValue]="selectedInvestorId()?.toString()" [updateWidth]="updateWidth()" [valueProperty]="'id'"
              [nameProperty]="'name'" [outerdivClass]="'investor'" [optionClass]="'font-bold'"
              [optionClassProperty]="'isVerified'" [selectClass]="'lg:whitespace-nowrap'"
            [type]="'Investors'"></app-auto-adjusting-dropdown>
          </div>
        </div>
      }
    </li>